import { Link } from "react-router-dom";

const reportPagePath = "/dashboard/4/reports/";

const reportsList = [
  {
    title: "Отчет по лицензиям",
    description: "Посмотреть отчет по лицензиям",
    path: `${reportPagePath}1`
  },
  {
    title: "Отчет по предписаниям",
    description: "Посмотреть отчет по предписаниям",
    path: `${reportPagePath}2`
  },

];

type ReportsListProps =  {
  onSetCrumbs: (crumbs: string) => void;
}

function ReportsList({ onSetCrumbs }: ReportsListProps) {
  return (
    <div>
      <div className="grid grid-cols-2 py-5 px-7.5 gap-5">
        {reportsList.map(report => (
          <div key={report.path}>
            <Link
              to={report.path}
              onClick={() => {
                onSetCrumbs(report.title);
              }}
              title={report.description}
              className="bg-white shadow-custom py-[60px] flex rounded-md justify-center gap-2 font-medium hover:text-darkblue"
            >
              {report.title}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsList;
